import i18n from "../../i18n/index";
export default {
  props: {
    missingDocumentsData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      headers: [
        {
          text: i18n.t("headers.patient-document"),
          sortable: false,
          align: "left"
        },
        {
          text: i18n.t("headers.patient-name"),
          sortable: false,
          align: "left"
        },
        {
          text: i18n.t("headers.nro-order"),
          sortable: false,
          value: "number"
        },
        {
          text: i18n.t("headers.provider"),
          value: "providerId",
          sortable: false
        },
        {
          text: i18n.t("headers.total-documents"),
          value: "providerId",
          sortable: false
        },
        {
          text: i18n.t("headers.total-moderator-fee-with-weights"),
          value: "providerId",
          sortable: false
        }
      ],
      itemsData: []
    };
  },
  watch: {
    missingDocumentsData() {
      this.itemsData = [];
      this.missingDocumentsData.forEach(items => {
        let item = {};
        item.orderNumber = items.orderNumber;
        item.providerName = items.providerName;
        item.documentCount = items.documentCount;
        item.scaleFeeTotal = Math.ceil(items.scaleFeeTotal); 
        if (items.patients.length === 1) {
          items.patients.forEach(patients => {
            item.documento = patients.identification;
            item.nombre = patients.name;
          });
        } else {
          let patients = "",
            names = "";
          items.patients.forEach(p => {
            let patient = p.identification;
            let namePatient = p.name;
            patients = patients.concat(patient + " - ");
            names = names.concat(namePatient + " - ");
          });
          item.documento = patients.trimRight(" - ");
          item.nombre = names.trimRight(" - ");
        }
        this.itemsData.push(item);
      });
    }
  }
};
